import { createBoundedUseStore } from 'common-functions';
import { Bundle } from 'server-schemas/channels/basket';
import { createStore } from 'zustand';

export type BundlesStoreType = {
  bundlesRecord: Record<string, Bundle[]>;
  bundleError: string;
  setBundle: (flightSegmentId: string, currencyCode: string | undefined, bundle: Bundle[]) => void;
  setBundleError: (error: string) => void;
  cleanBundleStore: () => void;
};

export const BundlesStore = createStore<BundlesStoreType>(set => ({
  bundlesRecord: {},
  bundleError: '',
  setBundle: (flightSegmentId: string, currencyCode: string | undefined, bundle: Bundle[]) => {
    if (currencyCode) {
      const bundlesRecordKey = `${flightSegmentId}-${currencyCode}`;
      return set(state => {
        return { ...state, bundlesRecord: { ...state.bundlesRecord, [bundlesRecordKey]: bundle } };
      });
    }
  },
  setBundleError: (error: string) => {
    return set(state => {
      return { ...state, bundleError: error };
    });
  },
  cleanBundleStore: () => {
    return set({ bundlesRecord: {}, bundleError: '' });
  }
}));

export const useBundlesStore = createBoundedUseStore(BundlesStore);
